// @ts-check
import { LBButton } from '@linearb/buzz';
import { Tooltip } from '@material-ui/core';
import useScimSetting from 'common/hooks/settings/useScimSetting';

const PermissionButton = ({
  disabled,
  variant,
  size,
  onClick,
  dataCy,
  children
}) => {
  const scimSetting = useScimSetting();
  const noPermissionTooltip = scimSetting.isEnabled
    ? scimSetting.disabledTooltip
    : null;
  const hasPermission = !noPermissionTooltip;

  return (
    <Tooltip title={noPermissionTooltip} disableHoverListener={hasPermission}>
      <span>
        <LBButton
          disabled={disabled || !hasPermission}
          variant={variant}
          size={size}
          onClick={onClick}
          data-cy={dataCy}
        >
          {children}
        </LBButton>
      </span>
    </Tooltip>
  );
};

export default PermissionButton;
